import { render, staticRenderFns } from "./BulkTranscriptionForm.vue?vue&type=template&id=5f332552"
import script from "./BulkTranscriptionForm.vue?vue&type=script&lang=js"
export * from "./BulkTranscriptionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports